export enum CouponViewState
{
    Init = 0,
    ShowCodeEntry = 1,
    ShowValue = 2,
    Invalid = 3,
    CashingError = 4
}